// extracted by mini-css-extract-plugin
export default {"products":"vz-z","card":"wz-z","oosMessaging":"xz-z"};